import { ReminderStates } from "../generated/django-enums";
import { getGlobalHeadersAsObject } from "../global-headers";

export { ReminderStates };

export type Reminder = {
	id: number;
	user_id: number;
	user_name: string;
	user_first_name?: string;
	user_email?: string;
	object_id: number;
	due_date: string;
	note: string;
	state: ReminderStates;
	content_name: string;
	content_type: number;
	updated: string;
	created: string;
};

export const getRemindersForObject = (
	objectName: string,
	objectId: number
): Promise<Reminder[]> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`getTagPerson called with invalid argument id '${objectId}'. Expected number`
		);
	}
	return fetch(`/api/v2/${objectName}/${objectId}/reminders/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const deleteReminder = (reminderId: number): Promise<unknown> => {
	if (!reminderId || typeof reminderId !== "number") {
		throw new Error(
			`deleteReminder called with invalid argument id '${reminderId}'. Expected number`
		);
	}
	return fetch(`/api/v2/reminders/${reminderId}/`, {
		method: "DELETE",
		headers: getGlobalHeadersAsObject(),
	})
		.then((res) => {
			return new Promise<void>((resolve) => resolve());
		})
		.catch((err) => console.log(err));
};

export const updateReminder = (reminder: Reminder): Promise<Reminder> => {
	return fetch(`/api/v2/reminders/${reminder.id}/`, {
		method: "PUT",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(reminder),
	})
		.then((res) => res.json())
		.catch((err) => console.log(err));
};

export const getExpiredRemindersForUser = (user_id: number): Promise<Reminder[]> => {
	if (!user_id || typeof user_id !== "number") {
		throw new Error(
			`createReminderForObject called with invalid argument id '${user_id}'. Expected number`
		);
	}
	return fetch(`/api/v2/reminders/?user_id=${user_id}&expired=true`, {
		method: "Get",
		headers: getGlobalHeadersAsObject(),
	})
		.then((res) => res.json())
		.catch((err) => console.log(err));
};

export const createReminderForObject = (
	objectName: string,
	objectId: number,
	reminder: Reminder
): Promise<Reminder> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`createReminderForObject called with invalid argument id '${objectId}'. Expected number`
		);
	}
	return fetch(`/api/v2/${objectName}/${objectId}/reminders/`, {
		method: "POST",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(reminder),
	})
		.then((res) => res.json())
		.catch((err) => console.log(err));
};
